export const selectReservations = state => state.admin.reservations;

export const selectIsLoading = state => state.admin.isLoading;

export const selectCoefficient = state => state.admin.coefficient;

export const selectGlobalSettings = state => state.admin.globalSettings;

export const selectPaginationInfo = state => state.admin.paginationInfo;
